import React, { useCallback } from 'react';
import * as PropTypes from 'prop-types';
import { Row, Radio } from 'grab-ui';
import cx from 'classnames';
import I18n from 'i18n-js';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import formatCurrency from 'common/utils/format-currency';
import calcPrice from 'common/utils/calc-price';
import { getInsuranceOptionID } from 'helper/insurance';
import styles from './insurance-options.less';

const InsuranceOptions = ({
  selectedInsuranceOptionID,
  options,
  optionsCount,
  showMultiplier,
  onChange,
}) => {
  const onSelect = useCallback(
    e => {
      onChange(e.target.value);
    },
    [onChange],
  );

  if (_isEmpty(options)) {
    return null;
  }

  return (
    <Row>
      <Radio.Group
        value={selectedInsuranceOptionID}
        onChange={onSelect}
        className={styles.insuranceOptions}
      >
        {options.map(option => {
          const displayMultiplier = _get(optionsCount, option.title, 0);
          const selected =
            selectedInsuranceOptionID === getInsuranceOptionID(option) ||
            displayMultiplier > 0;
          const shouldShowMultiplier =
            (selectedInsuranceOptionID !== undefined &&
              displayMultiplier > 1) ||
            (showMultiplier && displayMultiplier > 0);
          return (
            <Radio.Button
              value={getInsuranceOptionID(option)}
              key={option.insuranceSignature}
              className={cx(styles.insuranceOption, {
                [styles.selected]: selected,
                [styles.withMultiplier]: shouldShowMultiplier,
              })}
            >
              <p className={styles.title}>{option.title}</p>
              <p>
                <span
                  className={styles.multiplier}
                >{`${displayMultiplier} x `}</span>
                {option.isIncluded
                  ? I18n.t('v2.anytimeBooking.insurance.included')
                  : formatCurrency({
                      code: _get(option, 'currency.code'),
                      amount: calcPrice(option.optionPremium, option.currency),
                    })}
              </p>
            </Radio.Button>
          );
        })}
      </Radio.Group>
    </Row>
  );
};

InsuranceOptions.propTypes = {
  selectedInsuranceOptionID: PropTypes.number,
  optionsCount: PropTypes.shape({}),
  showMultiplier: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      insuranceSignature: PropTypes.string.isRequired,
      currency: PropTypes.shape({}),
    }),
  ).isRequired,
};

InsuranceOptions.defaultProps = {
  selectedInsuranceOptionID: undefined,
  optionsCount: undefined,
  showMultiplier: false,
};

export default InsuranceOptions;
